import ZigZagSectionOnline from './ZigZagSectionOnline'

export default ZigZagSectionOnline